









import {Component, Vue, Prop} from 'vue-property-decorator'

@Component({})

export default class AppButton extends Vue {
  @Prop({type: String, default: ''}) public buttonClass!: string
  @Prop({type: Boolean, default: false}) public disabled!: boolean

  public click() {
    if (!this.disabled) {
      this.$emit('onClick')
    }
  }
}
